import { chatbotHttp } from "./chatbotApi";

const root = (botId) => `/bots/${encodeURIComponent(botId)}/staff-commands`;
export const listStaffCommands = (botId) => chatbotHttp.get(root(botId)).then((r) => r.data);
export const getStaffCommandOptions = (botId) => chatbotHttp.get(`${root(botId)}/options`).then((r) => r.data);
export const createStaffCommand = (botId, body) => chatbotHttp.post(root(botId), body).then((r) => r.data);
export const updateStaffCommand = (botId, id, body) =>
  chatbotHttp.put(`${root(botId)}/${encodeURIComponent(id)}`, body).then((r) => r.data);
export const deleteStaffCommand = (botId, id) =>
  chatbotHttp.delete(`${root(botId)}/${encodeURIComponent(id)}`);
